type EventData = Record<string, string | number | boolean>

declare global {
    interface Window {
        umami?: { track: (event: string, data?: EventData) => void }
    }
}

// Sends a custom event to Umami. Does nothing on the server or when the
// script is blocked. Never pass usernames or other personal data here.
export function trackEvent(event: string, data?: EventData) {
    if (import.meta.server) return
    try {
        window.umami?.track(event, data)
    } catch {}
}
